/* ONAIR V2: return to the existing product form, never submit an alternate cart. */
(() => {
  'use strict';
  if (customElements.get('onair-product-return')) return;
  customElements.define('onair-product-return', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.button = this.querySelector('button');
      this.main = document.querySelector('.section-main-product');
      if (!this.main || !this.button) return;
      this.visible = element => {
        if (!element || element.closest('[hidden]')) return false;
        const style = getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      };
      this.find = selector => [...this.main.querySelectorAll(selector)].find(element =>
        !element.closest('sticky-buy-button,.sticky--add-to-cart-wrapper') && this.visible(element));
      this.purchase = this.find('[data-add-to-cart],button[name="add"]');
      if (!this.purchase) return;
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        this.frame = 0;
        if (!this.purchase.isConnected) this.purchase = this.find('[data-add-to-cart],button[name="add"]');
        if (!this.purchase) { this.button.hidden = true; return; }
        const modal = [...document.querySelectorAll('.side-drawer,dialog[open],[aria-modal="true"]')].some(element => this.visible(element) && element.getBoundingClientRect().right > 0 && element.getBoundingClientRect().left < innerWidth);
        const typing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,select,[contenteditable="true"]');
        const show = this.mobile.matches && this.purchase.getBoundingClientRect().bottom < 0 && !modal && !typing;
        if (this.button.hidden === show) this.button.hidden = !show;
        const preview = document.querySelector('#preview-bar-iframe');
        const rect = preview?.getBoundingClientRect();
        const offset = rect && rect.height <= 130 && rect.bottom >= innerHeight - 2 ? Math.round(rect.height) : 0;
        const value = offset + 'px';
        if (this.style.getPropertyValue('--onair-ux-preview-offset') !== value) this.style.setProperty('--onair-ux-preview-offset', value);
      };
      this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(this.update); };
      this.button.addEventListener('click', () => {
        const target = this.find('optionset,variants-set') || this.purchase;
        const header = document.querySelector('.section-header');
        const offset = (header?.getBoundingClientRect().height || 70) + 20;
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
        window.scrollTo({top,behavior:this.reduced.matches?'auto':'smooth'});
      }, options);
      window.addEventListener('scroll', this.queue, {...options,passive:true});
      window.addEventListener('resize', this.queue, options);
      window.addEventListener('load', this.queue, options);
      document.addEventListener('focusin', this.queue, options);
      document.addEventListener('focusout', this.queue, options);
      this.mobile.addEventListener('change',this.queue,options);
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.type === 'childList' || record.target === document.body || record.target.matches?.('.side-drawer,dialog,[aria-modal]'))) this.queue();
      });
      this.observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','aria-hidden']});
      document.body.classList.add('onair-ux-has-return');
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      document.body.classList.remove('onair-ux-has-return');
    }
  });
})();
